import React, { Component } from 'react';
import * as style from './timelineProgress.module.scss';

const radius = 38;
const circumference = Math.ceil(Math.PI * 2 * radius);

const ProgressCircle = ({ title, progress, link, position }) => {
  let progressCircle = null;
  if (typeof progress !== 'undefined') {
    let scrollProgress = position === 0 ? progress : 0;
    if (progress > 1) {
      scrollProgress = 1;
    }
    progressCircle = (
      <svg className={style.svgContainer}>
        <circle
          className={style.svgCircle}
          cx="50%"
          cy="50%"
          r={radius}
          style={{
            strokeDasharray: circumference,
            strokeDashoffset: circumference * (1 - scrollProgress),
          }}
        />
      </svg>
    );
  }

  return (
    <a
      href={link}
      className={
        position === 0 ? style.progressCircle : style.progressCircleInactive
      }
    >
      <span className={style.circleLabel}>{title}</span>
      {progressCircle}
    </a>
  );
};

export default ProgressCircle;
